import '../../../core/components/chart-grid/ChartGrid.css';
import './HistogramOverlays.css';
export var crosshairLayout = '_drl8ns1-3-12-1 _13lzg4k0-3-12-1';
export var datapointLayout = '_drl8ns0-3-12-1 _13lzg4k0-3-12-1';